var map = {
	"./gesellschaft-BG.jpg": 545,
	"./gesellschaft-BG_dm.jpg": 667,
	"./header.jpg": 823,
	"./header_dm.jpg": 593,
	"./international-BG.jpg": 756,
	"./international-BG_dm.jpg": 936,
	"./kultur-BG.jpg": 313,
	"./kultur-BG_dm.jpg": 979,
	"./lifestyle-BG.jpg": 103,
	"./lifestyle-BG_dm.jpg": 969,
	"./politik-BG.jpg": 502,
	"./politik-BG_dm.jpg": 762,
	"./sport-BG.jpg": 522,
	"./sport-BG_dm.jpg": 886,
	"./wirtschaft-BG.jpg": 411,
	"./wirtschaft-BG_dm.jpg": 733
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 535;